import cn from 'classnames'
import React, { memo } from 'react'

import { Translation } from 'cng-common/features/translations/components'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import styles from './ReadOnlyField.module.scss'

interface IProps {
  label?: React.ReactNode
  value: unknown
  variant?: 'horizontal' | 'vertical'
}

export const ReadOnlyField = memo<IProps>(({ label, value, variant = 'vertical' }) => {
  const renderedLabel =
    label === undefined || label === null || label === '' ? null : typeof label === 'string' ? (
      <Translation text={label} span />
    ) : (
      label
    )

  const labelNode = renderedLabel ? <label className={styles.label}>{renderedLabel}</label> : null

  if (typeof value === 'string' || typeof value === 'number') {
    const readOnlyValue = value || value === 0 ? value : '-'

    return (
      <fieldset className={cn(styles.readOnly, { [styles.horizontal]: variant === 'horizontal' })}>
        {labelNode}
        <div className={styles.value}>{readOnlyValue}</div>
      </fieldset>
    )
  }

  if (typeof value === 'boolean') {
    return (
      <fieldset className={cn(styles.readOnly, { [styles.horizontal]: variant === 'horizontal' })}>
        {labelNode}
        <div className={styles.value}>{value ? 'Yes' : 'No'}</div>
      </fieldset>
    )
  }

  if (value instanceof Date) {
    return (
      <fieldset className={cn(styles.readOnly, { [styles.horizontal]: variant === 'horizontal' })}>
        {labelNode}
        <div className={styles.value}>{getFormatDate(value, 'full')}</div>
      </fieldset>
    )
  }

  if (Array.isArray(value)) {
    const readOnlyValue = value?.length ? value.join(', ') : '-'

    return (
      <fieldset className={cn(styles.readOnly, { [styles.horizontal]: variant === 'horizontal' })}>
        {labelNode}
        <div className={styles.value}>{readOnlyValue}</div>
      </fieldset>
    )
  }

  if (React.isValidElement(value)) {
    return (
      <fieldset className={cn(styles.readOnly, { [styles.horizontal]: variant === 'horizontal' })}>
        {labelNode}
        <div className={styles.value}>{value}</div>
      </fieldset>
    )
  }

  return (
    <fieldset className={cn(styles.readOnly, { [styles.horizontal]: variant === 'horizontal' })}>
      {labelNode}
      <div className={styles.value}>-</div>
    </fieldset>
  )
})
